import { defineStore } from 'pinia'
import { useAppStore } from '@/store/modules/app'
import { useProductBackStore } from '@/store/modules/productBack'

export const useWatchStore = defineStore('watch', {
  state: () => {
    return {
      // 点赞数
      likeNumber: 0,
      // 待执行动画的点赞数
      likeNumberToAnimate: 0,
      // 播放器音量状态
      playerVolume: 1,
      // 回放状态：true-回放中，false-回放结束
      playbackStatus: false
    }
  },
  actions: {
    setPlaybackStatus(val: boolean) {
      this.playbackStatus = val
      if (val && useAppStore().config.recordProductMsg) {
        useProductBackStore().setProductBackMessage()
      } else {
        useProductBackStore().resetProductBackMessage()
      }
    }
  }
})
